import { getFileProviders, lazyLoadProviders } from 'owa-fileprovider-store';
import {
    loading,
    loadingFileProvidersFailed,
    openFolderSelector,
    reloadFolders,
    stoppedLoading,
} from '../actions/internalActions';
import { orchestrator } from 'satcheljs';
import { trace } from 'owa-trace';

/**
 * SHOULD NOT BE USED DIRECTLY. EXPORTED ONLY FOR TESTING
 */
export const loadFileProviderOrchestrator = orchestrator(openFolderSelector, async () => {
    const currentLoadedFileProviders = getFileProviders();

    if (!currentLoadedFileProviders || currentLoadedFileProviders.length === 0) {
        // Only run this if providers are not already loaded
        loading();
        const loadProviders = await lazyLoadProviders.import();
        const onProvidersLoaded = () => {
            stoppedLoading();
        };
        const onProvidersLoadingError = (error: Error) => {
            stoppedLoading();
            loadingFileProvidersFailed();
            trace.warn(`Unable to load file providers: ${error.toString()}`);
        };

        loadProviders(onProvidersLoaded, onProvidersLoadingError);
    } else {
        // If the providers are already loaded then reload current folder
        reloadFolders();
    }
});
